import _ from "lodash";

const peakABooHeader = ($) => {
	const header = $("#header");
	if (!header) return;

	const doc = document.documentElement;
	const w = window;

	let prevScroll = w.scrollY || doc.scrollTop;
	let curScroll;
	let direction = 0;
	let prevDirection = 0;

	const heightToShowBg = 200;

	// px value of when we slide the headerNav up
	const trigger = 30;

	const handleScroll = () => {
		/*
		 ** Find the direction of scroll
		 ** 0 - initial, 1 - up, 2 - down
		 */

		curScroll = w.scrollY || doc.scrollTop;

		const showBackground = curScroll > heightToShowBg;
		header.toggleClass("background", showBackground);

		if (curScroll > prevScroll) {
			//scrolled up
			direction = 2;
		} else if (curScroll < prevScroll) {
			//scrolled down
			direction = 1;
		}

		if (direction !== prevDirection) {
			toggleHeader(direction, curScroll);
		}

		prevScroll = curScroll;
	};

	const toggleHeader = (direction, curScroll) => {
		if (direction === 2 && curScroll > trigger) {
			header.addClass("nav-up");
		} else if (direction === 1) {
			header.removeClass("nav-up");
		}
		prevDirection = direction;
	};

	window.addEventListener("scroll", _.throttle(handleScroll, 200));
};

export default peakABooHeader;
